<template>
  <div class="edit-studio-container">

    <main class="tab-content">

      <h2 class="item text-secondary">FO form content:</h2>
      <div class="btn-container">
        <span id="cancelUser" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <form class="form-container admin-studio-tab-pane fade show active" id="admin_user_info">
        <div class="field-sec">
          <label>Country code:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.country_code" />
        </div>
        <div class="field-sec">
          <label>Title:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_form_title" />
        </div>
        <div class="field-sec">
          <label>Subtitle:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_form_sub_title" />
        </div>
        <div class="field-sec">
          <label>First name placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_first_name_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Last name placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_last_name_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Email placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_email_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Phone placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_phone_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Area placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.area_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Message placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_msg_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Submit button:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.send_btn_text" />
        </div>
        <div class="field-sec">
          <label class="">Thank you page:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.thank_you_page" />
        </div>
      </form>
      <h2 class="item text-secondary">Error messages:</h2>
      <form class="form-container admin-studio-tab-pane fade show active" id="error">
        <div class="field-sec">
          <label class="">First name error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_first" />
        </div>
        <div class="field-sec">
          <label class="">Last name error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_last" />
        </div>
        <div class="field-sec">
          <label class="">First & Last name error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_first_last" />
        </div>
        <div class="field-sec">
          <label class="">Email error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_email" />
        </div>
        <div class="field-sec">
          <label class="">Invalid email error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_email2" />
        </div>
        <div class="field-sec">
          <label class="">Phone error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_phone" />
        </div>
        <div class="field-sec">
          <label class="">Invalid phone error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_phone2" />
        </div>
        <div class="field-sec">
          <label class="">Area error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_area" />
        </div>
        <div class="field-sec">
          <label class="">Message error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_des" />
        </div>
      </form>
      <div class="btn-container">
        <span id="cancelUser2" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser2" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <br>
      <h3 class="text-secondary">Example:</h3>
      The example is for testing the content but may not be functional:
      <br>
      <div class="kmt" id="FO_form">
        <div class="right-side-kmt-form">
          <h2 id="kmt_form_title_fo" class="kmt-form-title">{{ fit20.blockToEdit.kmt_form_title }}</h2>
          <h3 id="kmt_form_subtitle_fo" class="kmt-form-subtitle">{{ fit20.blockToEdit.kmt_form_sub_title }}</h3>
          <form class="" id="form_field">
            <div class="kmt-error-container">
              <div class="kmt-error hidden" id="kmt_error"></div>
            </div>
            <ul class="kmt-fields">
              <li>
                <div>
                  <input id="kmt_first_name" type="text" value="" maxlength="255" fieldType="1" :placeholder="fit20.blockToEdit.kmt_first_name_placeholder
                    " disable />
                </div>
              </li>
              <li>
                <div>
                  <input id="kmt_last_name" type="text" maxlength="255" :placeholder="fit20.blockToEdit.kmt_last_name_placeholder
                    " disable />
                </div>
              </li>
              <li>
                <div>
                  <input id="kmt_email" type="email" maxlength="255" value="" :placeholder="fit20.blockToEdit.kmt_email_placeholder
                    " disable />
                </div>
              </li>
              <li>
                <div>
                  <div>
                    <input id="kmt_phone" type="text" :placeholder="fit20.blockToEdit.kmt_phone_placeholder
                      " disable />
                  </div>
                </div>
              </li>
              <li>
                <div>
                  <div>
                    <input id="kmt_area" type="text" :placeholder="fit20.blockToEdit.area_placeholder
                      " disable />
                  </div>
                </div>
              </li>
              <li>
                <div>
                  <textarea id="kmt_description" maxlength="65535" :placeholder="fit20.blockToEdit.kmt_msg_placeholder
                    " disable></textarea>
                </div>
              </li>
            </ul>
            <div class="zcwf_row">
              <div class="reCAPTCHA-text">
                This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service
                apply.
              </div>
              <div class="btn-container">
                <div class="btn-div">
                  <button data-sitekey="6Lfwco0iAAAAABguhve-qhu-bCyYNTiY8qK2KgTu" data-callback="onSubmit" type="button"
                    id="form_submit_fo" class="form-submit" onclick="">{{ fit20.blockToEdit.send_btn_text
                    }}</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <br>
      <div class="btn-container">
        <span id="cancelUser3" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser3" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
    </main>

  </div>
</template>

<script>
import isEqual from 'lodash/isEqual';



export default {
  name: 'FoForm',
  components: {

  },
  props: ["selectTab", "admin_fit20", "fit20", "admin", "saveBlock"],
  data() {
    return {
    };
  },
  methods: {
    isValidEmail: function (email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    cancelEditing: function () {
      if (!isEqual(this.fit20.blockToEdit, this.fit20.originalBlock)) {
        this.fit20.blockToEdit = {
          ...this.fit20.originalBlock
        };
        this.updated = true;
      }
    },
  },
  watch: {
    "fit20.blockToEdit": {
      deep: true, // Watch for changes in nested properties
      handler(newVal) {

        if (isEqual(newVal, this.fit20.originalBlock)) {
          $('#cancelUser').removeClass("cancel-btn-active");
          $('#saveUser').removeClass("save-btn-active");
          $('#cancelUser2').removeClass("cancel-btn-active");
          $('#saveUser2').removeClass("save-btn-active");
        } else {
          if (!$('#cancelUser').hasClass('cancel-btn-active')) {
            $('#cancelUser').addClass("cancel-btn-active");
            $('#saveUser').addClass("save-btn-active");
            $('#cancelUser2').addClass("cancel-btn-active");
            $('#saveUser2').addClass("save-btn-active");
          }
        }
      }
    },
  }
};
</script>

<style>
.edit-studio-container {
  width: 100%;
  overflow: auto;
}

.edit-studio-container .tab-content {
  padding-top: 15px;
}

.edit-studio-container .tab-content h2 {
  margin-left: 10px;
}

.edit-studio-container .img-container img {
  border-radius: 15px;
  cursor: pointer;
  max-width: 150px;
}

.edit-studio-container .admin-studio-tab-pane {
  display: none;
  padding-bottom: 30px;
}

.edit-studio-container .form-container.active {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: space-around;
}

.edit-studio-container .form-container div {
  width: calc(100% / 2 - 30px);
}

.edit-studio-container .form-container label {
  display: block;
}

.edit-studio-container .studio-users {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.edit-studio-container .users-col {
  width: calc(100%);
}

.edit-studio-container .studio-machines {
  width: 100%;
}

.edit-studio-container .ex-member-container {
  margin-top: 10px;
}

.edit-studio-container .ex-member-flex {
  width: 100% !important;
}

.edit-studio-container .ex-member-item {
  width: 80% !important;
  border: solid 1px var(--fit20-lighter-gray);
  padding: 5px 7px;
  border-radius: 10px;
  margin-bottom: 7px;
}

.edit-studio-container .ex-member-container img {
  margin-bottom: 7px;

}

.edit-studio-container .measure-div {
  position: relative;
}

.edit-studio-container .kg {
  position: absolute;
  right: 60px;
  bottom: 5px;
}

/*  fit20 FO form style */
.edit-studio-container .kmt {
  width: 100%;
  min-height: 500px;
  display: flex;
  background: url('https://www.fit20.com/files/images/Global/Global Grids/FIT02680\ -\ Headers\ website\ iconen\ patronen\ DNA\ -\ fit20\ franchise.png');
}

.edit-studio-container .kmt section {
  width: 80% !important;
  max-width: 1500px !important;
  margin: auto !important;
  font-family: sans-serif !important;
  background-color: white !important;
  padding: 20px !important;
  border-radius: 20px !important;
}

.edit-studio-container .kmt .kmt-form-subtitle {
  text-align: center;
  color: #616365 !important;
  margin-bottom: 15px;
}

.edit-studio-container .kmt h2 {
  margin-top: 0px !important;
  color: #92d400 !important;
}

.edit-studio-container .kmt ul {
  padding: 0 !important;
}

.edit-studio-container .kmt .right-side-kmt-form {
  width: 60% !important;
  max-width: 1500px !important;
  margin: auto !important;
  font-family: sans-serif !important;
  background-color: white !important;
  padding: 20px !important;
  border-radius: 20px !important;
}

.edit-studio-container .kmt .kmt-form-title {
  text-align: center !important;
  color: #92d400 !important;
  font-family: 'VAG Rounded Std light', Verdana, Geneva, Tahoma, sans-serif !important;
}

.edit-studio-container .kmt li {
  padding: 0 !important;
  list-style: none !important;
  line-height: normal !important;
}

.edit-studio-container .checkbox {
  padding-left: 0px !important;
  line-height: normal !important;
  color: #616365 !important;
  font-size: 14px !important;
  margin-bottom: 15px !important;
}

.edit-studio-container .checkbox input {
  display: inline !important;
  margin: 0 !important;
  width: 0 !important;
}

.edit-studio-container .checkbox label {
  display: inline !important;
  padding-left: 3px !important;
  margin-left: 2.5% !important;
}

.edit-studio-container .kmt .checkbox input[type='radio'] {
  opacity: 0 !important;
  height: 0 !important;
}

.edit-studio-container .kmt .checkbox input[type='radio']+*::before {
  content: '' !important;
  display: inline-block !important;
  vertical-align: middle !important;
  width: 10px !important;
  height: 10px !important;
  margin-right: 5px !important;
  margin-bottom: 1.3px !important;
  border-radius: 50% !important;
  border-style: solid !important;
  border-width: 2px !important;
  border-color: #5e7fb133 !important;
}

.edit-studio-container .kmt .checkbox input[type='radio']:checked+*::before {
  content: '' !important;
  display: inline-block !important;
  vertical-align: middle !important;
  width: 10px !important;
  height: 10px !important;
  margin-right: 5px !important;
  border-radius: 50% !important;
  border-style: solid !important;
  border-width: 2px !important;
  border-color: #95c11a !important;
  background: radial-gradient(#95c11a 0%, #95c11a 40%, transparent 50%, transparent) !important;
}

.edit-studio-container #crmWebToEntityForm.zcwf_lblTopBottom {
  width: 100% !important;
}

.edit-studio-container .kmt label {
  text-align: left !important;
  padding: 3px 0 3px 10px !important;
  font-size: 14px !important;
}

.edit-studio-container .kmt .kmt-fields {
  width: 100% !important;
  display: flex !important;
  justify-content: space-around !important;
  flex-wrap: wrap !important;
  padding-left: 10px !important;
  color: #616365 !important;
}

.edit-studio-container .kmt .kmt-fields li {
  width: 45% !important;
  margin-bottom: 15px !important;
}

.edit-studio-container .kmt .kmt-fields input {
  width: 100% !important;
  height: 40px !important;
}

.edit-studio-container .kmt .kmt-fields li:last-child,
.kmt .kmt-fields li:nth-last-child(2) {
  width: 95% !important;
}

.edit-studio-container .kmt .kmt-fields li:last-child input:last-child {
  width: 73% !important;
}

.edit-studio-container .kmt .kmt-fields input,
.edit-studio-container .kmt textarea {
  border: solid 1px #5e7fb133 !important;
  border-radius: 5px !important;
  padding: 3px 0px 3px 10px !important;
  outline: none !important;
  font-size: 14px !important;
}

.edit-studio-container .kmt textarea {
  width: 100% !important;
  height: 50px !important;
}

.edit-studio-container .kmt .reCAPTCHA-text {
  text-align: center !important;
  font-size: 11px !important;
  padding: 10px 0 15px 10px !important;
  color: #616365 !important;
}

.edit-studio-container .kmt .form-submit {
  cursor: pointer !important;
  color: #ffffff !important;
  background-color: #e5007d !important;
  border: solid 1px #e5007d !important;
  font-size: 15px !important;
  border-radius: 20px !important;
  padding: 7px 30px !important;
}

.edit-studio-container .kmt .form-submit:hover {
  background-color: transparent !important;
  color: #e5007d !important;
  transition: all 0.3s !important;
}

.edit-studio-container .btn-container {
  width: 100%;
  text-align: center !important;
}

.edit-studio-container .btn-div {
  display: inline-block !important;
  z-index: 1 !important;
  position: relative;
  margin: 0 auto !important;
  border-radius: 15px !important;
}

.edit-studio-container .btn-div:after {
  transition: all 0.3s !important;
  content: '' !important;
  background: #ffffff !important;
  border-radius: 15px !important;
  width: 0% !important;
  position: absolute !important;
  left: 0 !important;
  top: 0 !important;
  height: 100% !important;
  z-index: -1 !important;
}

.edit-studio-container .btn-div:hover:after {
  width: 100% !important;
}

.edit-studio-container .hidden {
  display: none !important;
}

.edit-studio-container .kmt-error {
  border: 1px solid red !important;
  border-radius: 10px !important;
  background-color: rgb(255, 215, 215) !important;
  text-align: center !important;
  font-size: 14px !important;
}

.edit-studio-container .display-none {
  display: none !important;
}

.edit-studio-container .kmt .selected {
  transition: all 0.1s !important;
  border: 2px solid #009fe3 !important;
}

@media only screen and (max-width: 900px) {
  .edit-studio-container .kmt .kmt-fields li:last-child {
    display: inline-block !important;
  }

  .edit-studio-container .kmt .kmt-fields li:last-child input:last-child {
    width: 63% !important;
  }
}

@media only screen and (max-width: 700px) {
  .edit-studio-container .kmt section {
    width: 90% !important;
    padding: 10px !important;
  }

  .edit-studio-container .kmt h2 {
    margin-top: 0px !important;
  }

  .edit-studio-container .kmt ul {
    padding: 0 !important;
  }

  .edit-studio-container .kmt .right-side-kmt-form {
    width: 80% !important;
  }

  .edit-studio-container .checkbox {
    font-size: 10px !important;
  }

  .edit-studio-container .checkbox label {
    display: block !important;
    font-size: 10px !important;
  }

  .edit-studio-container .kmt label {
    padding: 3px 0 3px 10px !important;
  }

  .edit-studio-container .kmt .kmt-fields {
    padding-left: 5px !important;
  }

  .edit-studio-container .kmt .kmt-fields input,
  .edit-studio-container .kmt .kmt-fields textarea,
  .edit-studio-container .kmt .kmt-fields label {
    font-size: 10px !important;
  }

  .edit-studio-container .kmt .kmt-fields li {
    width: 95% !important;
    margin-bottom: 5px !important;
  }

  .edit-studio-container .kmt .kmt-fields li:last-child {
    width: 95% !important;
  }

  .edit-studio-container .kmt .kmt-fields li:last-child input:last-child {
    width: 95% !important;
  }

  .edit-studio-container .kmt .reCAPTCHA-text {
    font-size: 9px !important;
    padding: 5px 0 5px 10px !important;
  }

  .edit-studio-container .kmt .form-submit {
    font-size: 12px !important;
    padding: 5px 20px !important;
  }

  .edit-studio-container .hidden {
    display: none !important;
  }

  .edit-studio-container .kmt-error {
    border: 1px solid red !important;
    border-radius: 10px !important;
    background-color: rgb(255, 215, 215) !important;
    text-align: center !important;
    font-size: 10px !important;
  }
}
</style>